var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCircleRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5V21.5C17.2467 21.5 21.5 17.2467 21.5 12H20.5ZM12 20.5C7.30558 20.5 3.5 16.6944 3.5 12H2.5C2.5 17.2467 6.75329 21.5 12 21.5V20.5ZM3.5 12C3.5 7.30558 7.30558 3.5 12 3.5V2.5C6.75329 2.5 2.5 6.75329 2.5 12H3.5ZM12 3.5C16.6944 3.5 20.5 7.30558 20.5 12H21.5C21.5 6.75329 17.2467 2.5 12 2.5V3.5Z",
    fill: "#14181F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3536 8.64645C11.1583 8.45118 10.8417 8.45118 10.6464 8.64645C10.4512 8.84171 10.4512 9.15829 10.6464 9.35355L11.3536 8.64645ZM14 12L14.3536 12.3536C14.4473 12.2598 14.5 12.1326 14.5 12C14.5 11.8674 14.4473 11.7402 14.3536 11.6464L14 12ZM10.6464 14.6464C10.4512 14.8417 10.4512 15.1583 10.6464 15.3536C10.8417 15.5488 11.1583 15.5488 11.3536 15.3536L10.6464 14.6464ZM10.6464 9.35355L13.6464 12.3536L14.3536 11.6464L11.3536 8.64645L10.6464 9.35355ZM13.6464 11.6464L10.6464 14.6464L11.3536 15.3536L14.3536 12.3536L13.6464 11.6464Z",
    fill: "#14181F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleRight);
export default __webpack_public_path__ + "static/media/icon-circle-right.bd71ac2d2fc879b767775c20e3d56907.svg";
export { ForwardRef as ReactComponent };